<template>
  <v-app>
    <div id="app">
<!--  todo: hide the toolbar stuff if authenticated from app (however we want to do that)    -->
      <v-toolbar v-if="!noHeader" flat dark color="itoviBlueDarkest" class="pt-3 pb-3">
        <img @click="goHome" style="cursor: pointer;" class="pl-4" src="./assets/itovi_blue.png" height="35"/>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="font-weight-bold mr-3" flat v-if="showLogoutBtn" @click="logout">Logout</v-btn>
          <v-btn class="font-weight-bold mr-3" flat v-if="showLoginBtn" @click="login">Login</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card v-if="!noHeader" flat color="itoviBlueDark" style="height: 1px" ></v-card>
<!--      <v-divider></v-divider>-->




      <template v-if="$route.matched.length">
        <router-view></router-view>
      </template>
      <template v-else>
<!--        <p>You are logged {{ loggedIn ? 'in' : 'out' }}</p>-->
      </template>

<!--      <div id="nav">-->
<!--        <router-link to="/">Home</router-link> |-->
<!--        <router-link to="/about">About</router-link>-->
<!--      </div>-->
<!--      <router-view/>-->
    </div>
  </v-app>
</template>

<style lang="scss">
  #app {
     font-family: Montserrat, Arial, sans-serif;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
     text-align: center;
     color: #2c3e50;
   }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>

<script>

  import auth from './auth'

  export default {
    data () {
      return {
        noHeader: false,
        loggedIn: auth.loggedIn(),
        showLoginBtn: true,
        showLogoutBtn: false
      }
    },
    created () {
      this.configureAppBar()
    },
    updated () {
      this.configureAppBar()
    },
    methods: {
      goHome() {
        this.$router.replace('/')
      },
      logout () {
        auth.logout()
        this.$router.replace('/login')
        // refresh the appbar if we are already on the home page
        if (this.$router.currentRoute.name === 'home') this.configureAppBar()
      },
      login () {
        this.$router.replace('/login')
      },
      async configureAppBar () {
        this.loggedIn = auth.loggedIn()
        this.showLoginBtn = !this.loggedIn && this.$router.currentRoute.name !== 'login'
        this.showLogoutBtn = this.loggedIn
        this.noHeader = this.$route.query.hasOwnProperty('apptoken') && this.loggedIn
      }
    }
  }
</script>
